/* unplugin-vue-components disabled */import script from "./Option.vue?vue&type=script&setup=true&lang=js"
export * from "./Option.vue?vue&type=script&setup=true&lang=js"

import "./Option.vue?vue&type=style&index=0&id=56dc0bec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56dc0bec"]])

export default __exports__